var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-wrap"},[_c('div',{staticClass:"label",style:({'background-color': _vm.backgroundColor}),on:{"click":function($event){return _vm.changeBackgroundColor($event)}}}),_c('Tooltip',{attrs:{"position":"tr"}},[_c('div',{staticClass:"&__label"},[_vm._v(_vm._s(_vm.labelName))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }